var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "State",
    transform: "translate(-256.83 58.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1302",
    "data-name": "Ellipse 1302",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(256.83 -58.25)",
    fill: "#39be9d",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-state-2456627",
    transform: "translate(178.879 -83.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34415",
    "data-name": "Path 34415",
    d: "M101.936,322.923l-1.688-4.477a.6.6,0,0,0-.7-.36l-4.97,1.442-2.409-.512v1.2l2.314.512a.72.72,0,0,0,.284,0l4.591-1.347,1.271,3.414-3.6,1.252H86.666l-1.385-2.428,2.58-2.314,1.138.247v-1.2l-1.2-.266a.643.643,0,0,0-.512.133l-3.149,2.845a.578.578,0,0,0-.114.721l1.8,3.13a.623.623,0,0,0,.512.284H97.118a.647.647,0,0,0,.19-.019l4.268-1.48a.669.669,0,0,0,.341-.3.593.593,0,0,0,.019-.474Z",
    transform: "translate(0 -276.991)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34416",
    "data-name": "Path 34416",
    d: "M262.669,44.528a.591.591,0,0,0,.588-.588V38.533h5.615a.591.591,0,0,0,.588-.588V33.108a.591.591,0,0,0-.588-.588h-5.615v-.569a.588.588,0,1,0-1.176,0V43.94a.6.6,0,0,0,.588.588ZM268.3,33.7v3.661h-5.046V33.7Z",
    transform: "translate(-172.096)",
    fill: "#39be9d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgState);
export default __webpack_public_path__ + "static/media/State.0e0e03cca58bff05bf8936515b625734.svg";
export { ForwardRef as ReactComponent };